<template>
  <div class="page">
    <van-nav-bar title="纠偏事项" left-arrow @click-left="$router.back()"/>
    <van-skeleton v-if="loading" title :row="10"/>
    <main v-else-if="item.id">
      <header><em>{{ statusLabel }}</em>
        <h1>{{ item.title }}</h1>
        <p v-if="item.rationale">{{ item.rationale }}</p></header>
      <section><h2>行动要求</h2>
        <ol>
          <li v-for="(action,i) in item.actions" :key="i">{{ action }}</li>
        </ol>
      </section>
      <section v-if="item.employeeFeedback"><h2>沟通记录</h2>
        <p>{{ item.employeeFeedback }}</p></section>
      <section v-if="item.supervisorReviewNote"><h2>主管意见</h2>
        <p>{{ item.supervisorReviewNote }}</p></section>
      <section v-if="item.completionNote"><h2>完成结果</h2>
        <p>{{ item.completionNote }}</p><a v-if="item.evidenceReference" :href="item.evidenceReference" target="_blank"
                                           rel="noopener">查看成果依据</a></section>
      <div v-if="item.status==='CONVEYED'" class="actions">
        <van-button type="danger" @click="act('ACCEPT')">采纳</van-button>
        <van-button plain type="danger" @click="feedback('CHANGE_REQUEST')">申请修改</van-button>
        <van-button plain @click="feedback('DISPUTE')">提出异议</van-button>
      </div>
      <van-button v-else-if="item.status==='ACCEPTED'" block type="danger" @click="act('START')">开始执行</van-button>
      <van-button v-else-if="item.status==='IN_PROGRESS'" block type="danger" @click="submitResult">提交结果</van-button>
    </main>
  </div>
</template>
<script>
import coreapi from '@/utils/coreapi';

export default {
  data() {
    return {item: {}, loading: false}
  }, computed: {
    statusLabel() {
      return {
        CONVEYED: '等待回应',
        ACCEPTED: '已采纳',
        CHANGE_REQUESTED: '已申请修改',
        DISPUTED: '已提出异议',
        IN_PROGRESS: '执行中',
        SUBMITTED: '等待主管验收',
        VERIFIED: '已完成'
      }[this.item.status] || this.item.status
    }
  }, mounted() {
    this.load()
  }, methods: {
    async load() {
      this.loading = true;
      try {
        this.item = await coreapi.correction(this.$route.params.id)
      } catch (e) {
        this.$toast.fail(e.message)
      } finally {
        this.loading = false
      }
    }, async act(action, payload) {
      try {
        this.item = await coreapi.correctionAction(this.item.id, {action, ...payload});
        this.$toast.success('状态已更新')
      } catch (e) {
        this.$toast.fail(e.message)
      }
    }, feedback(action) {
      this.$dialog.prompt({
        title: action === 'DISPUTE' ? '说明异议' : '提出修改建议',
        message: '请写明事实和建议'
      }).then(v => this.act(action, {feedback: v})).catch(() => {
      })
    }, submitResult() {
      this.$dialog.prompt({
        title: '提交完成结果',
        message: '说明完成情况和可验证成果'
      }).then(v => this.act('SUBMIT', {completionNote: v})).catch(() => {
      })
    }
  }
}
</script>
<style lang="less" scoped>@import '~@/assets/base.less';

.page {
  min-height: 100vh;
  background: #f6f7fb
}

main {
  padding: .28rem
}

header, section {
  margin-bottom: .16rem;
  padding: .3rem;
  background: #fff;
  border-radius: .16rem
}

header em {
  padding: .05rem .14rem;
  color: @color;
  background: #fff1f1;
  border-radius: .08rem;
  font-size: .22rem;
  font-style: normal
}

h1 {
  margin-top: .16rem;
  font-size: .4rem;
  line-height: 1.35
}

h2 {
  font-size: .32rem
}

p, li {
  color: #626577;
  font-size: .27rem;
  line-height: 1.6
}

header p {
  margin-top: .12rem
}

ol {
  margin: .14rem 0 0;
  padding-left: .4rem
}

a {
  display: inline-block;
  margin-top: .12rem;
  color: @color
}

.actions {
  display: grid;
  grid-template-columns:1fr 1fr 1fr;
  gap: .12rem
}

.actions .van-button {
  min-width: 0;
  padding: 0 .08rem
}</style>



// WEBPACK FOOTER //
// src/views/efficiency/CorrectionDetail.vue